import { CADConnectionType, Tier } from '@app/shared/enums';

export class SiteApiModel {
  public Id: number;
  public Title: string;
  public Tier: Tier;
  public MaxStorage: number;
  public MaxUploadSize: number;
  public UsersCount: number;
  public StorageUsed: number;
  public LastLogin: Date | null = null;
  public Created: Date;
  public Guid: string;
  public IsActive: boolean;
  public ActiveDirectoryEnabled: boolean;
  public POWER_SUITE_EID_AUTH: boolean;
  public Secure_Sign_in: boolean;
  public MentoringEnabled: boolean;
  public TrainingCoursesEnabled: boolean;
  public CadImportEnabled: boolean;
  public PowerDmsSiteId: string;
  public SiteKeyInternal: string;
  public SalesforceId: string;
  public FoundationUserManagementEnabled: boolean;
  public SyncPlatformExtendedUserFieldsEnabled: boolean;
  public PlatformTasksEnabled: boolean;
  public PipEnabled: boolean;
  public RatingScaleUpdateEnabled: boolean;
  public AssignPolicyDocumentsEnabled: boolean;
  public RaceAndSexReportingEnabled: boolean;
  public UserwayEnabled: boolean;
  public AITraineeSummaryMasterEnabled: boolean;
  public PowerEngageIntegrationEnabled: boolean;
  public CADImportConnectionType: CADConnectionType;

  public deserialize(data: object): this {
    Object.assign(this, data);

    this.Created = new Date(this.Created);

    this.LastLogin = new Date(this.LastLogin);

    return this;
  }
}
